export default __webpack_public_path__ + "static/media/rogers.31d4b4e9.png";